import React from 'react';
import { BasecampLayout } from '../components/Layout';
import { PageHeader, EmptyState } from '../components/UI';

// Najava za oblasti koje dolaze u kasnijim fazama (WP-2 — WP-4).
// Sidebar ih prikazuje da bi navigacija odgovarala punom mockup-u.
export default function ComingSoon({ title, subtitle, phase, message }) {
  return (
    <BasecampLayout>
      <PageHeader title={title} subtitle={subtitle} />
      <EmptyState
        icon="🏔"
        title={`Coming in ${phase}`}
        message={message}
      />
    </BasecampLayout>
  );
}
